import {
  Sun,
  Cloud,
  CloudSun,
  CloudRain,
  CloudDrizzle,
  CloudSnow,
  CloudLightning,
  CloudFog,
  CloudHail,
  Snowflake,
  CloudRainWind,
} from "lucide-react";

const MAP = {
  "sun":              { Icon: Sun,            color: "#F59E0B" }, // amber
  "cloud-sun":        { Icon: CloudSun,       color: "#F59E0B" },
  "cloud":            { Icon: Cloud,          color: "#64748B" }, // slate
  "cloud-drizzle":    { Icon: CloudDrizzle,   color: "#3B82F6" }, // blue-500
  "cloud-rain":       { Icon: CloudRain,      color: "#2563EB" }, // blue-600
  "cloud-rain-wind":  { Icon: CloudRainWind,  color: "#1D4ED8" }, // blue-700
  "cloud-snow":       { Icon: CloudSnow,      color: "#60A5FA" },
  "snowflake":        { Icon: Snowflake,      color: "#60A5FA" },
  "cloud-lightning":  { Icon: CloudLightning, color: "#F59E0B" },
  "cloud-fog":        { Icon: CloudFog,       color: "#94A3B8" },
  "cloud-hail":       { Icon: CloudHail,      color: "#60A5FA" },
};

export default function WeatherIcon({ name, size = 28, strokeWidth = 1.75, className = "" }) {
  const entry = MAP[name] || MAP.sun;
  const { Icon, color } = entry;
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      color={color}
      data-testid={`weather-icon-${name}`}
    />
  );
}
